import { render, staticRenderFns } from "./stockReceiveSelectedItems.vue?vue&type=template&id=4d80ef95"
import script from "./stockReceiveSelectedItems.vue?vue&type=script&lang=js"
export * from "./stockReceiveSelectedItems.vue?vue&type=script&lang=js"
import style0 from "./stockReceiveSelectedItems.vue?vue&type=style&index=0&id=4d80ef95&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports